import { ClientOnly } from '@/components/ClientOnly';

import useMe from '@/renderer/utils/useMe';

import SkeletonDMList from './SkeletonDMList';

export default function DMStaffList(_props: { chatId: API.Id | 'me' }) {
  const me = useMe();

  const isStaff = me?.role === 'staff' || me?.role === 'admin';

  return (
    isStaff && (
      // Below lg this is one carousel pane sized w-full to the content area (the
      // viewport minus the app sidebar) — NOT w-[100dvw], which is viewport-wide and
      // overflowed the sidebar-padded area, clipping the panes (#1984). At lg+ it is
      // the fixed 288px conversation-list column beside the open conversation.
      <div
        // This pane has its own top chrome (Header when the list has loaded, the
        // skeleton's placeholder bar before that), so it owns its top safe-area
        // inset independently of the conversation pane beside it. Without the
        // region marker the sibling pane's chrome claimed the inset for the whole
        // page and this pane lost the layout's fallback (#2053) — see
        // renderer/utils/safeTop.tsx.
        data-safe-top-region
        className="w-full shrink-0 snap-start overflow-y-auto border-zinc-900/10 border-r bg-zinc-50 lg:w-72 dark:border-r-white/10 dark:bg-transparent"
      >
        <ClientOnly component={() => import('./DMList')}>
          <SkeletonDMList />
        </ClientOnly>
      </div>
    )
  );
}
